import { RotatingLines } from "react-loader-spinner";

import { ActivityIndicatorContainer } from "./styles";
import { LoaderProps } from "./types";
import { theme } from "../../layout";

export const ActivityIndicator = ({
  style,
  radius = 20,
  color = theme.loader.default,
}: LoaderProps) => {
  return (
    <ActivityIndicatorContainer style={style}>
      <RotatingLines visible width={radius.toString()} strokeColor={color} />
    </ActivityIndicatorContainer>
  );
};
